import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Field, Form, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import "../styles/pay.scss";
import { SecondaryApi } from "../api/baseApi";

const PayWIth = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const isQPath = location.pathname.startsWith("/q");
  const { rowId } = useParams();

  let data = JSON.parse(sessionStorage.getItem("paymentData") || "{}");
  // let cartData = JSON.parse(sessionStorage.getItem("cartData") || "{}");
  const idramFormRef = useRef(null);
  const amountRef = useRef(null);
  const idramOrderRef = useRef(null);
  const [errMessages, setErrMessages] = useState("");

  const [paymentData, setPaymentData] = useState({});
  const [cartData, setCartData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      if (isQPath && rowId) {
        try {
          setLoading(true);

          const response = await SecondaryApi.post(
            "/api/apartment-identification-for-message",
            { id: rowId },
          );

          const responseData = response?.data?.data || {};

          setPaymentData(responseData);
          setCartData(responseData);

          sessionStorage.setItem("paymentData", JSON.stringify(responseData));
          sessionStorage.setItem("cartData", JSON.stringify(responseData));
        } catch (error) {
          console.error(error);
          setErrMessages("Failed to load payment data");
        } finally {
          setLoading(false);
        }
      } else {
        const savedPaymentData = JSON.parse(
          sessionStorage.getItem("paymentData") || "{}",
        );
        const savedCartData = JSON.parse(
          sessionStorage.getItem("cartData") || "{}",
        );

        setPaymentData(savedPaymentData);
        setCartData(savedCartData);
      }
    };

    loadData();
  }, [isQPath, rowId]);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem("paymentData");
      sessionStorage.removeItem("cartData");
    };
  }, []);

  const validationSchema = Yup.object({
    amount: Yup.string().required("Դաշտը պարտադիր է"),
    card_type: Yup.string().required("Դաշտը պարտադիր է"),
    email: Yup.string()
      .email("Սխալ էլ.փոստի ֆորմատ")
      .when("card_type", (card_type, schema) =>
        card_type == "epayment"
          ? schema.required("Էլ.փոստը պարտադիր է")
          : schema.notRequired(),
      ),
  });

  const info = [
    {
      id: 1,
      title: "Հասցե",
      value: data?.address ?? "",
      icon: "/assets/images/icons/location.svg",
    },
    {
      id: 2,
      title: "Անուն Ազգանուն",
      value: data?.owner_name ?? "",
      icon: "/assets/images/icons/user-full.svg",
    },
    {
      id: 3,
      title: "Նույնականացման տվյալը",
      value: data?.account_id ?? "",
      icon: "/assets/images/icons/information.svg",
    },
    {
      id: 4,
      title: "Ծառայություն",
      value: data?.service_name ?? "",
      icon: "/assets/images/icons/location.svg",
    },
    {
      id: 5,
      title: "Ամսական վճար",
      value: data?.monthPrice ?? "",
      icon: "/assets/images/icons/money.svg",
    },
  ];

  const formCards = [
    // {
    //   id: "idram",
    //   icon: "/assets/images/icons/idram.png",
    //   iconWidth: 87,
    //   iconHeight: 42,
    //   customStyles: "",
    // },
    // {
    //   id: "bankCard",
    //   label: "Bank's card",
    //   icon: "/assets/images/icons/bank-card.svg",
    //   iconWidth: 41,
    //   iconHeight: 26,
    //   customStyles : ""
    // },
    {
      id: "epayment",
      label: "Պետական վճարումների էլեկտրոնային համակարգ",
      icon: "/assets/images/icons/epayments.png",
      iconWidth: 90,
      iconHeight: 26,
      customStyles: "customResponsive",
    },
  ];

  const filteredCards = formCards.filter((card) => {
    if (card.id === "idram" && cartData?.community_id === "6") {
      return false;
    }
    return true;
  });

  async function idramPay(amount) {
    try {
      if (cartData?.identification_data && cartData?.service_id && amount) {
        let payload = {
          account_id: cartData?.identification_data,
          amount,
          service_id: cartData?.service_id,
        };
        const response = await SecondaryApi.post(`/api/payment-idram`, payload);
        if (response.status && response.status < 400) {
          idramOrderRef.current.value = response.data.orderNumber;
          amountRef.current.value = amount;
          submitForm();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  async function epaymentPay(values) {

    try {
      if (cartData?.service_id && values) {
        let payload = {
          email: values?.email ?? "",
          amount: values?.amount ?? "",
          service_id: cartData?.service_id ?? "",
          community_id: cartData?.community_id ?? "",
          account_id: cartData?.identification_data ?? "",
        };
        const response = await SecondaryApi.post(
          `/api/payments/register`,
          payload,
        );

        if (
          response.status &&
          response.status < 400 &&
          response?.data?.data?.redirect_url
        ) {
          window.location.href = response?.data?.data?.redirect_url;
        }
      }
    } catch (error) {
      console.error(error);
      if (error.response) {
        let errResponse = error.response.data;
        if (errResponse && errResponse.ResponseMessage) {
          setErrMessages(errResponse.ResponseMessage);
        }
      } else if (error.request) {
        console.log("No response received:", error.request);
      } else {
        console.log("Error:", error.message);
      }
      //user12@mailinator.com
    }
  }

  const handleFormSubmit = (values) => {
    if (values.card_type === "idram") {
      idramPay(values.amount);
    } else if (values.card_type === "epayment") {
      epaymentPay(values);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
    sessionStorage.removeItem("paymentData");
  };

  const submitForm = () => {
    if (idramFormRef.current) {
      idramFormRef.current.requestSubmit();
      sessionStorage.removeItem("paymentData");
      sessionStorage.removeItem("cartData");
    }
  };

  const defaultCardType =
    filteredCards.length === 1 ? filteredCards[0].id : "idram";

  return (
    <>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <section className="contact  padding-b-60 section-bg position-relative z-index-1 overflow-hidden">
          <div className="container container-three py-4">
            <button
              id="demo-button-header "
              onClick={() => handleGoBack()}
              className="d-flex gap-2 theme-text"
              style={{ cursor: "pointer" }}
            >
              <span className="icon-left icon icon-filter">
                <img src="/assets/images/icons/arrow-left.svg" alt="" />
              </span>
              Վերադառնալ
            </button>
          </div>
          <div className="container container-three">
            <div className="row">
              <div className="col-12">
                <div className="card common-card p-4">
                  <Formik
                    initialValues={{
                      card_type: defaultCardType,
                      amount: "",
                      email: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleFormSubmit}
                    enableReinitialize
                    validateOnBlur
                    validateOnChange={false}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      setFieldValue,
                      submitCount,
                      isValid,
                      dirty,
                      setErrors,
                      setTouched,
                    }) => {
                      return (
                        <Form autoComplete="off">
                          <div className="row g-5 theme-text flex-lg-row flex-column">
                            <div
                              className="col-12 col-lg-5 d-flex flex-column"
                              style={{ minHeight: "100%" }}
                            >
                              <div
                                className="d-flex flex-column gap-4"
                                style={{ height: "100%" }}
                              >
                                <div
                                  className="d-flex flex-column align-items-center p-3"
                                  style={{
                                    gap: "10px",
                                    borderRadius: "15px",
                                    backgroundColor: "#FADDDD",
                                  }}
                                >
                                  <p
                                    className="text-center text-uppercase fw-normal mb-0"
                                    style={{
                                      color: "#B30000",
                                      fontSize: "18px",
                                      lineHeight: "22px",
                                    }}
                                  >
                                    ՊԱՐՏՔ
                                  </p>
                                  <p
                                    className="text-center fw-semibold mb-0"
                                    style={{
                                      color: "#B30000",
                                      fontSize: "32px",
                                    }}
                                  >
                                    {data?.debt} ֏
                                  </p>
                                </div>

                                <div
                                  className="bg-white d-flex flex-column gap-3 "
                                  style={{
                                    padding: "30px 20px",
                                    borderRadius: "15px",
                                    border: "1px solid #DBDBDB",
                                    height: "100%",
                                  }}
                                >
                                  {info.map((item) => (
                                    <div key={item.id} className="d-flex gap-3">
                                      <div
                                        className="d-flex align-items-center justify-content-center"
                                        style={{
                                          background: "#468D4F",
                                          width: "24px",
                                          height: "24px",
                                          padding: "3px",
                                          borderRadius: "3px",
                                        }}
                                      >
                                        <img
                                          src={item.icon}
                                          alt=""
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                          }}
                                        />
                                      </div>
                                      <div>
                                        <p
                                          className="text-left text-uppercase fw-medium"
                                          style={{
                                            color: "#535353",
                                            fontSize: "12px",
                                            lineHeight: "22px",
                                          }}
                                        >
                                          {item.title}
                                        </p>
                                        <p
                                          className="text-left text-capitalize fw-medium theme-text"
                                          style={{
                                            fontSize: "16px",
                                          }}
                                        >
                                          {item.value}
                                        </p>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>

                            <div
                              className="col-12 col-lg-7 d-flex flex-column"
                              style={{ height: "100%" }}
                            >
                              <div
                                className="bg-white border p-4 flex-grow-1"
                                style={{ borderRadius: "15px" }}
                              >
                                <div className="border-bottom p-4">
                                  <p
                                    className="fw-bold theme-text mb-0"
                                    style={{
                                      fontSize: "24px",
                                      lineHeight: "34px",
                                    }}
                                  >
                                    Ընտրեք Վճարման տարբերակը
                                  </p>
                                </div>

                                <div className="py-4 d-flex flex-column gap-5">
                                  <div
                                    className="d-flex align-items-start w-100 rounded"
                                    style={{
                                      minHeight: "35px",
                                      padding: "0 6px",
                                      gap: "10px",
                                      background: "#E8ECFD",
                                      marginBottom: "12px",
                                    }}
                                  >
                                    <img
                                      src="/assets/images/icons/info-circle.svg"
                                      alt=""
                                      width={20}
                                      height={20}
                                      style={{ marginTop: "5px" }}
                                    />
                                    <p
                                      className="fw-medium"
                                      style={{
                                        color: "#002BBA",
                                        fontSize: "14px",
                                        lineHeight: "27px",
                                      }}
                                    >
                                      Վճարման համար Դուք կտեղափոխվեք ընտրված
                                      վճարային համակարգի պաշտոնական կայք:
                                      Վճարումը կատարելուց հետո հաշիվը կթարմացվի
                                      անմիջապես։
                                    </p>
                                  </div>

                                  <div className="d-flex flex-column flex-xl-row gap-4">
                                    {filteredCards.map((card) => {
                                      const isSelected =
                                        values.card_type === card.id;

                                      return (
                                        <div
                                          key={card.id}
                                          className={`payment-card d-flex align-items-center gap-3  w-100 w-md-auto
                                        ${filteredCards.length === 1 ? "payment-card-single" : "px-4 py-4 payment-card-multi"}
                                        ${filteredCards.length > 1 && isSelected ? "selected" : ""}
                                      `}
                                          onClick={() => {
                                            setFieldValue("card_type", card.id);
                                            setFieldValue("email", "");
                                          }}
                                        >
                                          {filteredCards.length > 1 ? (
                                            <div
                                              className="rounded-circle d-flex align-items-center justify-content-center"
                                              style={{
                                                width: "20px",
                                                height: "20px",
                                                border: `1px solid ${isSelected ? "#468D4F" : "#c0bfbf"}`,
                                              }}
                                            >
                                              {isSelected && (
                                                <div
                                                  className="rounded-circle"
                                                  style={{
                                                    width: "12px",
                                                    height: "12px",
                                                    background: "#468D4F",
                                                  }}
                                                />
                                              )}
                                            </div>
                                          ) : null}

                                          <div
                                            className={`d-flex flex-row gap-2 align-items-center flex-nowrap flex-xl-wrap ${card.customStyles}`}
                                          >
                                            <img
                                              src={card.icon}
                                              alt={card.label}
                                              width={card.iconWidth}
                                              height={card.iconHeight}
                                            />
                                            {card.label && (
                                              <span
                                                style={{ fontSize: "12px" }}
                                              >
                                                {card.label}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>

                                  {values.card_type === "epayment" && (
                                    <div>
                                      <div
                                        className="d-flex align-items-start w-100 rounded"
                                        style={{
                                          minHeight: "35px",
                                          padding: "0 6px",
                                          gap: "10px",
                                          background: "#E8ECFD",
                                          marginBottom: "12px",
                                        }}
                                      >
                                        <img
                                          src="/assets/images/icons/info-circle.svg"
                                          alt=""
                                          width={20}
                                          height={20}
                                          style={{ marginTop: "5px" }}
                                        />
                                        <p
                                          className="fw-medium"
                                          style={{
                                            color: "#002BBA",
                                            fontSize: "14px",
                                            lineHeight: "27px",
                                          }}
                                        >
                                          {t("payWith.emailAlert")}
                                        </p>
                                      </div>

                                      <div className="d-flex flex-column gap-2 align-items-start w-100">
                                        <label
                                          htmlFor="email"
                                          className="theme-text fw-semibold mb-0 w-100"
                                          style={{
                                            fontSize: "18px",
                                            lineHeight: "27px",
                                          }}
                                        >
                                          Էլ․հասցե{" "}
                                          <span style={{ color: "#FF3636" }}>
                                            *
                                          </span>
                                        </label>

                                        <div className="col-12 col-md-8 position-relative d-flex align-items-center p-0">
                                          <Field
                                            type="email"
                                            name="email"
                                            id="email"
                                            className="common-input common-input--grayBg border  w-100 w-md-50 pe-5"
                                            onChange={(e) => {
                                              setFieldValue(
                                                "email",
                                                e.target.value,
                                              );
                                              setTouched({ email: true });
                                              setErrMessages("");
                                            }}
                                          />
                                        </div>

                                        {(errors.email ||
                                          touched.email ||
                                          submitCount > 0) &&
                                          errors.email && (
                                            <div className="text-danger small mt-1">
                                              {errors.email}
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  )}

                                  <div className="d-flex flex-column gap-2 align-items-start w-100">
                                    <label
                                      htmlFor="amount"
                                      className="theme-text fw-semibold mb-0 w-100"
                                      style={{
                                        fontSize: "18px",
                                        lineHeight: "27px",
                                      }}
                                    >
                                      Մուտքագրեք գումարի չափը
                                    </label>

                                    <div className="col-12 col-md-6 position-relative d-flex align-items-center p-0">
                                      <Field
                                        type="number"
                                        name="amount"
                                        id="amount"
                                        className="common-input common-input--grayBg border  w-100 w-md-50 pe-5"
                                        onChange={(e) => {
                                          setFieldValue(
                                            "amount",
                                            e.target.value,
                                          );
                                          setErrMessages("");
                                          setTouched({ amount: true });
                                        }}
                                      />

                                      <span
                                        className="position-absolute"
                                        style={{
                                          right: "10px",
                                          color: "#979797",
                                          fontSize: "24px",
                                        }}
                                      >
                                        ֏
                                      </span>
                                    </div>

                                    {(touched.amount || submitCount > 0) &&
                                      errors.amount && (
                                        <div className="text-danger small mt-1">
                                          {errors.amount}
                                        </div>
                                      )}
                                    {errMessages && (
                                      <div className="text-danger small mt-1">
                                        {errMessages}
                                      </div>
                                    )}
                                  </div>

                                  <div className="row">
                                    <div className="col-12 col-md-6">
                                      <button
                                        type="submit"
                                        className="btn btn-main pill w-100 py-3 py-md-4"
                                        disabled={
                                          !isValid ||
                                          errors.amount ||
                                          !dirty ||
                                          (values.card_type === "epayment" &&
                                            !values.email)
                                        }
                                      >
                                        Վճարել
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
          <form
            ref={idramFormRef}
            action="https://banking.idram.am/Payment/GetPayment"
            method="POST"
            style={{ display: "none" }}
          >
            <input type="hidden" name="EDP_LANGUAGE" value="EN" />
            <input
              type="hidden"
              name="EDP_REC_ACCOUNT"
              value={process.env.REACT_APP_IDRAM_KEY || ""}
            />
            <input
              type="hidden"
              name="EDP_DESCRIPTION"
              value="Order description"
            />
            <input ref={amountRef} type="hidden" name="EDP_AMOUNT" />
            <input ref={idramOrderRef} type="hidden" name="EDP_BILL_NO" />
          </form>
        </section>
      )}
    </>
  );
};

export default PayWIth;
